<template>

  <div>
    <div class="skinny row"  v-if="loading">
      <div class="col-md-12">
        <div class="loading-sunflower"></div>
      </div>
    </div>
    <div v-else>
      <!-- <div v-if="add">
        <form @submit.prevent="saveCard()" id="payment-form">
          <div class="skinny row form-group" v-if="admin != true">
            <div class="col-md-12">
              <label>Ingresa los datos de tu tarjeta.</label>
            </div>
          </div>
          <div class="skinny row form-group">
            <div class="col-md-6">
              <label for="name_card">Nombre del Titular de la Tarjeta</label>
              <input type="text" id="name_card" value="" class="form-control" data-openpay-card="holder_name" v-model="name_card">
            </div>
            <div class="col-md-6">
              <label for="card_number">Número de la Tarjeta</label>
              <input type="text" id="card_number" value="" class="form-control" data-openpay-card="card_number" v-model="card_number">
            </div>
          </div>
          <div class="skinny row form-group">
            <div class="col-md-6">
              <div class="skinny row">
                <div class="col-md-12 nopad">
                  <label for="">Fecha de Expiración</label>
                </div>
              </div>
              <div class="skinny row">
                <div class="col-md-6 nopad">
                  <select class="form-control" name="" data-openpay-card="expiration_month" v-model="month">
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                </div>
                <div class="col-md-6 nopad">
                  <select class="form-control" name="" data-openpay-card="expiration_year" v-model="year">
                        <option value="20">20</option>
                        <option value="21">21</option>
                        <option value="22">22</option>
                        <option value="23">23</option>
                        <option value="24">24</option>
                        <option value="25">25</option>
                        <option value="26">26</option>
                        <option value="27">27</option>
                        <option value="28">28</option>
                        <option value="29">29</option>
                        <option value="30">30</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <label for="">Código de Seguridad</label>
              <input type="text" name="" value="" class="form-control" data-openpay-card="cvv2" v-model="cvv">
            </div>
          </div>
          <div class="form-group">
            <div class="col-md-12 text-center">
              <input type="hidden" name="token_id" id="token_id">
              <input type="hidden" name="use_card_points" id="use_card_points" value="false">
              <button v-if="cards.length > 0 && !loading" type="button" name="button" class="btn btn-ins" @click="add = false">Regresar</button>
              <button v-if="!loading" type="submit" name="button" class="btn btn-ins" id="pay_button">Agregar</button>
            </div>
          </div>
        </form>
        <div class="skinny row">
          <div class="col-md-12">
            <p><strong>*Tus datos se manejan de forma segura con encriptaci&oacute;n de 256 bits.</strong></p>
          </div>
        </div>
      </div>
      <div v-else> -->
        <div class="skinny row" v-if="admin != true">
          <div class="col-md-12">
            <p><strong>Elige la tarjeta a la cual se le realizará el cargo:</strong></p>
          </div>
        </div>
        <div class="skinny row">
          <div class="col-md-12">
              <vs-table
              ref="cardsTable"
              stripe
              v-model="card_selected"
              :data="cards"
              noDataText="No se econtraron tarjetas de este solicitante"
              >
              <template slot="thead">
                <vs-th>No. tarjeta</vs-th>
                <vs-th>Tipo</vs-th>
                <vs-th>Banco</vs-th>
              </template>
              <template slot-scope="{ data }">
                  <vs-tr
                  :key="indextr"
                  v-for="(tr, indextr) in data"
                  :data="tr"
                  >
                    <vs-td>{{ tr.card_number }}</vs-td>
                    <vs-td>{{ tr.card_brand.toUpperCase() }}</vs-td>
                    <vs-td>{{ tr.bank_name.toUpperCase() }}</vs-td>
                  </vs-tr>
              </template>
              </vs-table>
          </div>
        </div>
        <!-- <div class="skinny row">
          <div class="col-md-12">
            <div class=" alt-1"></div>
            <a class="new-card-button" style="font-size: 18px; font-family: 'gilroybold';" @click="addNewCard">Agregar nueva tarjeta</a>
          </div>
        </div> -->
      <!-- </div> -->
    </div>
    <div class="modal fade" id="showCardErrorModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document" style="top:50px;">
        <div class="modal-content">
          <div class="modal-header">
            <a data-dismiss="modal" aria-label="Close" class="close close-modal">
    					<img :src="StorageURL + '/img/icons/close-modal.png'" style="width:30px">
    				</a>
            <h1 class="modal-title text-center" id="myModalLabel">Lo sentimos</h1>
          </div>
          <div class="modal-body text-center">
            <p>{{message}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script lang="js">
  export default  {
    name: 'cards',
    props: ['usuario', 'admin'],
    mounted() {
      // OpenPay.setId(op_data);
      // OpenPay.setApiKey(op_public);
      // OpenPay.setSandboxMode(!op_production);
      this.loading = true
      this.$emit('selected', this.card_selected)
      axios.get('/api/user/cards/get_for_cashing/' + this.usuario).then(response => {
        this.loading = false
        this.cards = response.data
        // if(this.cards.length == 0){
        //   this.add = true
        // }
      }).catch(error => {
        // this.add = true
        this.loading = false
      })
    },
    watch:{
      card_selected: function(){
        this.$emit('selected', this.card_selected)
      }
    },
    data() {
      return {
        loading: false,
        add: false,
        cards: [],
        card_selected: '',
        message: '',
        brand: '',
        name_card: '',
        card_number: '',
        cvv: '',
        month: '',
        year: '',
        card_id: '',
        device: '',
        confirm_cvv: '',
      }
    },
    methods: {
      addNewCard(){
        this.card_selected = ''
        this.name_card = ''
        this.card_number = ''
        this.cvv = ''
        this.month = ''
        this.year = ''
        this.add= true
      },
      // saveCard() {
      //   let m = this
      //   m.loading = true
      //   var deviceSessionId = OpenPay.deviceData.setup("payment-form", "deviceIdHiddenFieldName")
      //   var success_callbak = function(response) {
      //     m.brand = response.data.card.brand
      //     let data = {
      //       user_id: m.usuario,
      //       device: deviceSessionId,
      //       card_name: m.name_card,
      //       num_card: m.card_number,
      //       cvv: m.cvv,
      //       month: m.month,
      //       year: m.year
      //     }
      //     axios.post('/api/user/cards/save', data).then(resolve => {
      //       m.card_selected = resolve.data
      //       m.cards.push(resolve.data)
      //       m.loading = false
      //       m.add= false
      //     }).catch(error => {
      //       m.message = error.response.data
      //       m.loading = false
      //       $(`#showCardErrorModal`).modal('show');
      //     })
      //   }
      //   var error_callbak = function(response) {
      //     var desc = response.data.description != undefined ?
      //       response.data.description : response.message;
      //     console.log("ERROR [" + response.status + "] " + desc);
      //     m.message = 'Revisa bien los datos que ingresaste.'
      //     m.loading = false
      //     $(`#showCardErrorModal`).modal('show');
      //   }
      //   OpenPay.token.extractFormAndCreate('payment-form', success_callbak, error_callbak)
      // },
      // deleteCard(card_id){
      //   this.card_selected = ''
      //   //this.loading = true
      //   let data = {
      //     user_id: this.usuario,
      //     card_id: card_id
      //   }
      //   this.loading = true
      //   axios.post('/api/user/cards/delete', data).then(response => {
      //     this.cards = this.cards.filter(function(item) {
      //         return item.id !== card_id
      //     })
      //     if(this.cards.length == 0){
      //       this.addNewCard()
      //     }

      //     this.loading = false
      //   }).catch(error => {
      //     this.message = error.response.data
      //     this.loading = false
      //     $(`#showCardErrorModal`).modal('show');
      //   })
      // },
    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .cards {

  }
  a.new-card-button{
    color:#3b3a3e;
  }
  a.new-card-button:hover{
    cursor: pointer;
    text-decoration: underline;
    color:#3b3a3e;
  }

  .cards-table td{
    padding: 5px 10px;
  }

  .cards-table td.select-card{

  }

  .cards-table td.select-card:hover{
    background-color:rgba(0,0,0,.075);
    cursor: pointer;
  }
/*Estilos del radio*/
  /* The container */
.input-check {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.input-check input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: absolute;
  top: 5px;
  left: 0;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  border:solid 1px #3b3a3e;
}

/* On mouse-over, add a grey background color */
.input-check:hover input ~ .checkmark {
}

/* When the radio button is checked, add a blue background */

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.input-check input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.input-check .checkmark:after {
 	top: 4px;
	left: 4px;
	width: 5px;
	height: 5px;
	border-radius: 50%;
	background: #3b3a3e;
}

</style>
